/**
 * Automatically shows the correct "Nu open" / "Nu gesloten" store-status label
 * on the homepage "Bezoek onze winkel" card, based on the store's opening hours
 * in Belgian local time (Europe/Brussels), and hides the label that doesn't apply.
 *
 * Opening hours:
 *   Mon-Fri: 10:00-18:00
 *   Sat:     10:00-17:00
 *   Sun:     closed, except in October when it follows Saturday's hours (10:00-17:00)
 *
 * The two labels are theme "Group" blocks named "time-label-open" and
 * "time-label-closed" in the customizer (Home page > ... > Bezoek onze winkel).
 * Their block IDs are hard-coded below since that's the only stable hook available.
 * If either block is ever deleted and re-added in the customizer, update the IDs
 * here to match (select the block in the customizer, then inspect its element's
 * id attribute in the page source, or ask a developer to look it up).
 *
 * Shopify renders each block's id attribute with a random per-request prefix
 * (e.g. "AbC123__group_j48PCK"), so elements are matched by the end of their
 * id rather than an exact id, using an attribute selector.
 */
(function () {
  var OPEN_LABEL_ID = 'group_j48PCK';
  var CLOSED_LABEL_ID = 'group_pKCimi';

  function findLabel(blockId) {
    return document.querySelector('[id$="__' + blockId + '"], [id="' + blockId + '"]');
  }

  function isStoreOpenNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Brussels',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      month: 'numeric',
      hour12: false,
    }).formatToParts(new Date());

    var values = {};
    parts.forEach(function (part) {
      values[part.type] = part.value;
    });

    var dayIndex = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[values.weekday];
    var minutesNow = parseInt(values.hour, 10) * 60 + parseInt(values.minute, 10);
    var month = parseInt(values.month, 10); // 1-12

    if (dayIndex >= 1 && dayIndex <= 5) {
      // Monday - Friday: 10:00-18:00
      return minutesNow >= 10 * 60 && minutesNow < 18 * 60;
    }
    if (dayIndex === 6) {
      // Saturday: 10:00-17:00
      return minutesNow >= 10 * 60 && minutesNow < 17 * 60;
    }
    // Sunday: closed, except in October (same hours as Saturday)
    if (month === 10) {
      return minutesNow >= 10 * 60 && minutesNow < 17 * 60;
    }
    return false;
  }

  function updateStoreStatusLabels() {
    var openLabel = findLabel(OPEN_LABEL_ID);
    var closedLabel = findLabel(CLOSED_LABEL_ID);
    if (!openLabel || !closedLabel) return;

    var open = isStoreOpenNow();
    openLabel.style.display = open ? '' : 'none';
    closedLabel.style.display = open ? 'none' : '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateStoreStatusLabels);
  } else {
    updateStoreStatusLabels();
  }
})();
